<template>
    <v-card class="custom-dailog show-feedback-popup">
        <status-overlay :action="loadingAction"></status-overlay>
        <v-card-title :class="thankYouDialog ? 'success-bg' : ''">
            {{FeedbackConstants.SHARE_YOUR_FEEDBACK}}
            <i class="fas fa-times"
               data-qe-id="feedback_close_icon"
               @click="closeFeedback"></i>
        </v-card-title>
        <v-card-text class="inner-scrollbar">
            <v-flex class="form-submit" v-if="!thankYouDialog && mainDialog">
                <div v-for='(feedbackQuestion,index) in feedbackQuestions' :key="index">
                    <v-flex mb-3 v-if="!feedbackQuestion.editMode && (feedbackQuestion.display || feedbackQuestion.canEdit)">
                        <h6>
                            {{feedbackQuestion.question}}
                            <i class="fas fa-pencil-alt"
                               v-if="feedbackQuestion.canEdit"
                               data-qe-id="feedback_edit_question_one"
                               icon
                               @click="editQuestion(index)"></i>
                        </h6>
                        <v-textarea
                            v-if="feedbackQuestion.answerType === FeedbackConstants.QUESTION_TYPES.TEXT_MESSAGE"                            
                            v-model="feedbackQuestion.FeedBackAnswer"
                            name="FeedbackMessage"
                            counter
                            data-qe-id="feedback_message_text_area"
                            maxlength="1000"
                            required>
                        </v-textarea>
                        <star-rating
                            v-if="feedbackQuestion.answerType === FeedbackConstants.QUESTION_TYPES.RATING"
                            :show-rating="false"
                            data-qe-id="feedback_star_rating"
                            :star-size="30"
                            v-model="feedbackQuestion.FeedBackAnswer"></star-rating>
                        <v-flex class="action-btns" v-if="feedbackQuestion.answerType === FeedbackConstants.QUESTION_TYPES.VOTE">
                            <v-btn flat icon @click="thumbsVoting(index,true)">
                                <v-icon data-qe-id="feedback_thumbs_up"
                                        :class="[feedbackQuestion.FeedBackAnswer && feedbackQuestion.FeedBackAnswer === FeedbackConstants.VOTING_TYPE.THUMBS_UP ? 'active' : '']">
                                    fas fa-thumbs-up
                                </v-icon>
                            </v-btn>
                            <v-btn flat icon @click="thumbsVoting(index,false)">
                                <v-icon data-qe-id="feedback_thumbs_down"
                                        :class="[feedbackQuestion.FeedBackAnswer && feedbackQuestion.FeedBackAnswer === FeedbackConstants.VOTING_TYPE.THUMBS_DOWN ? 'active' : '']">
                                    fas fa-thumbs-down
                                </v-icon>
                            </v-btn>
                        </v-flex>
                    </v-flex>
                    <v-flex tag="p" v-if="feedbackQuestion.editMode" mt-3>
                        <v-text-field
                            solo
                            v-model="feedbackQuestion.question"
                            :data-qe-id="`feedback_question_${index}_edit_text_area`"
                            counter
                            maxlength=150></v-text-field>
                        <span class="error-color"
                              :data-qe-id="`feedback_question_${index}_error`"
                              v-if="feedbackQuestion.errorInfo && isValidQuestion(index)">
                            {{feedbackQuestion.errorInfo}}
                        </span>
                        <v-flex xs12>
                            <v-checkbox
                                attach
                                v-model="feedbackQuestion.display"
                                label="Display this question"
                                color="ypo_cta"
                                :data-qe-id="`feedback_display_question_${index}_checkbox`"
                                :disabled="disableCheckBox && feedbackQuestion.display"
                                hide-details></v-checkbox>
                        </v-flex>
                        <v-select
                            attach
                            :items="items"
                            v-model="feedbackQuestion.answerType"
                            item-text="key"
                            :data-qe-id="`feedback_question_${index}_rating_type_drop-down`"
                            item-value="value"
                            solo></v-select>
                        <v-flex xs12 text-xs-center>
                            <v-btn class="primary_btn transparent"
                                   :data-qe-id="`feedback_question_${index}_cancel_btn`"
                                   small
                                   @click="clearText(index)">
                                {{appCommonConstants.CANCEL}}
                            </v-btn>
                            <v-btn
                                class="primary_btn"
                                :data-qe-id="`feedback_question_${index}_update_btn`"
                                :disabled="isValidQuestion(index)"
                                small
                                @click="updateQuestion(index)">{{appCommonConstants.UPDATE}} </v-btn>
                        </v-flex>
                    </v-flex>
                </div>
                <v-flex class="file-upload" v-if="feedbackQuestions">
                    <h6>Share a screenshot <span>(Optional)</span></h6>
                    <div>
                        <form
                            ref="fileform"
                            v-on:drag.stop.prevent
                            v-on:dragstart.stop.prevent
                            v-on:dragend.stop.prevent
                            v-on:dragover.stop.prevent
                            v-on:dragenter.stop.prevent
                            v-on:dragleave.stop.prevent
                            v-on:drop.stop.prevent="onDropFiles"
                            class="drop-area">
                            <v-flex class="upload">
                                <i class="fas fa-image" ></i> Drop here or
                                <input type="file"
                                       id="browse"
                                       ref="feedbackFileControl"
                                       data-qe-id="feedback_screen-shot_browse_link"
                                       @change="onFileChange"
                                       style="display:none;"  multiple accept="image/*" />
                                <label for="browse"><b>Browse</b></label>
                            </v-flex>
                        </form>
                    </div>
                    <v-flex class="tiles">
                        <v-layout row wrap>
                            <v-flex
                                xs2
                                class="tiles__image"
                                v-for="(file,i) in files"
                                :key="i">
                                <v-img :src="file.url" width="50" height="100" />
                                <v-btn icon :data-qe-id="`feedback_screen-shot_${i}_close`"
                                       @click="removeImage(file,i)">
                                    <v-icon>fas fa-times</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex v-if="isError">
                <span class="error-color"> {{'Error: '}}{{isErrorMessage}}</span>
            </v-flex>
            <v-flex v-if="thankYouDialog" class="show-feedback-popup__success">
                <h1>{{FeedbackConstants.THANKYOU}}</h1>
                <span v-html="FeedbackConstants.THANKYOU_DESCRIPTION"></span>
            </v-flex>
        </v-card-text>
        <v-card-actions v-if="!thankYouDialog">
            <v-flex text-xs-right class="pa-3">

                <v-btn
                    :loading="isSubmitting"
                    @click="submitFeedback()"
                    :disabled="!isFormValid"
                    data-qe-id="feedback_submit_btn"
                    class="primary_btn medium">Submit</v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { FeedbackConstants } from "./AssistPageConstants";
    import { mapGetters, mapActions, mapState } from "vuex";
    import StarRating from 'vue-star-rating';
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import { appCommonConstants } from "../appCommon.constants";

    export default {
        name: "Feedback",
        components: {
            StarRating,
            StatusOverlay,
        },
        props: {
            closeFeedBackDialog: {
                type: Function,
                required: true,
            },

             mainDialog: {
                type: Boolean,
                required: true,
            },
            
        },
        data: () => {
            return {
                items: [
                    { key: 'Text Box', value: FeedbackConstants.QUESTION_TYPES.TEXT_MESSAGE },
                    { key: 'Star Rating', value: FeedbackConstants.QUESTION_TYPES.RATING },
                    { key: 'Thumbs Up/Down', value: FeedbackConstants.QUESTION_TYPES.VOTE },
                ],
                appCommonConstants,
                valid: false,
                submitFeedbackObj: {
                    Screenshots: [],
                },
                editQuestionIndex: "",
                FeedbackConstants,
                files: [],
                fileTypesSupported: ['.bmp',
                    '.gif',
                    '.jpeg',
                    '.jpg',
                    '.png',
                ],
                thankYouDialog: false,
                isSubmitting: false,
                isError: false,
                isErrorMessage: '', 
                isSubmitted: false,               
            };
        },

        created() {
            this.getFeedbackQuestions();
        },
        methods: {
            ...mapActions({
                getFeedbackQuestions: `feedback/${storeAction.getFeedbackQuestions}`,
                submitFeedbackForm: `feedback/${storeAction.submitFeedbackForm}`,
                updateFeedbackQuestion: `feedback/${storeAction.updateQuestionType}`,
            }),
            thumbsVoting(index, vote) {
                this.feedbackQuestions[index].FeedBackAnswer = vote ? FeedbackConstants.VOTING_TYPE.THUMBS_UP : FeedbackConstants.VOTING_TYPE.THUMBS_DOWN;
            },
            onFileChange(e) {
                this.isError = false;
                const filesCount = e.target.files.length + this.files.length;
                if (e.target.files && e.target.files.length <= 6 && filesCount <= 6) {
                    this.selectedFiles = e.target.files;
                    let objVal = false;
                    for (let i = 0; i < this.selectedFiles.length; i += 1) {
                        const browseVal = this.selectedFiles[i].name.lastIndexOf(".");
                        const BrowseFilename = this.selectedFiles[i].name.substring(0, browseVal);
                        if (BrowseFilename.length < 30) {
                            objVal = this.validateFileType(this.selectedFiles[i]);
                            if (objVal) {
                                if (this.filesCountValidation()) {
                                    this.selectedFiles[i].url = this.imageUrl(this.selectedFiles[i]);
                                    this.files.push(this.selectedFiles[i]);
                                }
                            } else {
                                this.isError = true;
                                this.isErrorMessage = "selected file type not correct type";
                            }
                        } else {
                            this.isError = true;
                            this.isErrorMessage = FeedbackConstants.IMAGE_NAME_LENGTH_ERROR;
                        }
                    }
                } else {
                    this.isError = true;
                    this.isErrorMessage = FeedbackConstants.NO_OF_FILES_ERROR;
                    if (this.files.length === 0) {
                        this.files = [];
                    }
                }
                if (this.isError) {
                    setTimeout(() => {
                        this.isErrorMessage = '';
                        this.isError = false;
                    }, 3000);
                }
                this.$refs.feedbackFileControl.value = '';
            },
            onDropFiles(e) {
                this.isError = false;
                this.isErrorMessage = "";
                const filesCount = e.dataTransfer.files.length + this.files.length;
                if (e.dataTransfer.files && e.dataTransfer.files.length <= 6 && filesCount <= 6) {
                    const droppedFiles = e.dataTransfer.files;
                    for (let i = 0; i < droppedFiles.length; i += 1) {
                        const value = droppedFiles[i].name.lastIndexOf(".");
                        const droppedFilename = droppedFiles[i].name.substring(0, value);
                        if (droppedFilename.length < 30) {
                            if (this.validateFileType(droppedFiles[i])) {
                                if (this.filesCountValidation()) {
                                     droppedFiles[i].url = this.imageUrl(droppedFiles[i]);
                                    this.files.push(droppedFiles[i]);
                                }
                            }
                        } else {
                            this.isError = true;
                            this.isErrorMessage = FeedbackConstants.IMAGE_NAME_LENGTH_ERROR;
                        }
                    }
                } else {
                    this.isError = true;
                    this.isErrorMessage = FeedbackConstants.NO_OF_FILES_ERROR;
                    if (this.files.length === 0) {
                        this.files = [];
                    }
                }

                if (this.isError) {
                    setTimeout(() => {
                        this.isErrorMessage = '';
                        this.isError = false;
                    }, 3000);
                }
            },
            isValidQuestion(index) {
                const isQuestionLengthValid = this.feedbackQuestions && this.feedbackQuestions[index].question.length > 150;
                if (isQuestionLengthValid) {
                    this.feedbackQuestions[index].errorInfo = FeedbackConstants.QUESTION_LENGTH_ERROR;
                }
                return isQuestionLengthValid;
            },
            validateFileType(file) {
                return (file.type === "image/png" || file.type === "image/jpeg");
            },
            filesCountValidation() {
                return this.files.length < 6;
            },
            imageUrl(file) {
                return URL.createObjectURL(file);
            },
            editQuestion(index) {
                this.feedbackQuestions.forEach((o) => { o.editMode = false; });
                this.editedQuestion = Object.assign({}, this.feedbackQuestions.slice(index, index + 1)[0]);
                this.feedbackQuestions[index].editMode = true;
                this.editQuestionIndex = index;
            },
            clearText() {
                if (this.feedbackQuestions.some(o => o.editMode)) {
                    this.resetQuestion();
                }
                this.feedbackQuestions.forEach((o) => { o.editMode = false; });
            },
            resetQuestion() {
                if (this.editQuestionIndex !== "") {
                    const index = this.editQuestionIndex;
                    this.feedbackQuestions[index].question = this.editedQuestion.question;
                    this.feedbackQuestions[index].display = this.editedQuestion.display;
                    this.feedbackQuestions[index].answerType = this.editedQuestion.answerType;
                    this.editQuestionIndex = "";
                }
            },
            updateQuestion(index) {
                this.updateFeedbackQuestion(JSON.parse(JSON.stringify(this.feedbackQuestions[index])));
                this.feedbackQuestions[index].editMode = false;
                this.feedbackQuestions.forEach((item) => {
                    item.editMode = false;
                    item.FeedBackAnswer = item.answerType === 'rating' ? 0 : '';
                });
            },
            closeFeedback() {
                this.clearText();
                this.clearData();    
            },
            clearData() {
                this.files = [];
                this.feedbackQuestions.forEach((o) => {
                    o.FeedBackAnswer = o.answerType === FeedbackConstants.QUESTION_TYPES.RATING ? 0 : '';
                });                
                this.isError = false;
                this.isErrorMessage = '';
                this.closeFeedBackDialog();
                this.thankYouDialog = false;
            },
            submitFeedback() {
                this.isSubmitting = true;
                const formData = new FormData();
                formData.append('Feedback', JSON.stringify(this.feedbackQuestions));
                for (let i = 0; i < this.files.length; i += 1) {
                    formData.append(`Screenshots[${i}]`, this.files[i]);
                }
                this.submitFeedbackForm(formData).then(() => {
                        this.submitFeedbackObj.Screenshots = [];
                        this.thankYouDialog = true;
                        this.files = [];
                        this.isSubmitting = false;
                        this.isError = false;
                        this.isErrorMessage = '';
                    })
                    .catch((err) => {
                        this.isError = true;
                        this.isErrorMessage = err;
                        this.isSubmitting = false;
                        this.isError = false;
                    });
            },
            removeImage(imageObj) {
                const index = this.files.findIndex(item => item.name === imageObj.name);
                this.files.splice(index, 1);
                if (this.files.length === 0) {
                    this.files = [];
                }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                feedbackQuestions: `feedback/${storeGetters.feedbackQuestions}`,
            }),
            loadingAction() {
                return this.actions[storeAction.getFeedbackQuestions];
            },
            isFormValid() {
                const val = this.feedbackQuestions.some(o => o.FeedBackAnswer && o.answerType !== FeedbackConstants.QUESTION_TYPES.TEXT_MESSAGE);
                const messageInValid = this.feedbackQuestions.some(o => o.FeedBackAnswer && o.answerType === FeedbackConstants.QUESTION_TYPES.TEXT_MESSAGE && o.FeedBackAnswer.length > 1000);
                const validMessage = this.feedbackQuestions && this.feedbackQuestions.some(o => o.answerType === FeedbackConstants.QUESTION_TYPES.TEXT_MESSAGE &&
                    o.FeedBackAnswer && o.FeedBackAnswer.length <= 1000);
                return (val || validMessage) && !messageInValid;
            },
            descriptionError() {
                return (this.submitFeedbackObj.FeedbackMessage && this.submitFeedbackObj.FeedbackMessage.length > 1000) ? FeedbackConstants.FEEDBACK_LENGTH_ERROR : '';
            },
            disableCheckBox() {
                return this.feedbackQuestions.filter(o => o.display).length === 1;
            },

        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .show-feedback-popup {
        h6 {
            font-size: 16px;
            color: $ypo-blue;
            font-weight: bold;
            line-height: normal;
            margin-bottom: 15px;
            word-break: break-word;

            span {
                color: $ypo-gray;
            }

            i {
                cursor: pointer;

                &:hover {
                    color: $ypo-cta;
                }
            }
        }

        .v-textarea {
            textarea {
                max-height: 118px;
                margin-top: 0;
                font-size: 14px;
                border-radius: 10px;
                margin-top: 0 !important;
            }
        }

        .v-messages__message {
            line-height: inherit;
        }

        .v-input__slot {
            box-shadow: none !important;
            border: 1px solid rgba($ypo-blue, 0.4);
            border-radius: 5px !important;
            padding: 7px 10px;

            &:before {
                border: 0 !important;
            }
        }

        .v-text-field {
            padding-top: 0;
        }

        .v-input--checkbox {
            .v-input__slot {
                border: 0;
                padding: 0;
                margin-bottom: 15px;
            }

            .v-label {
                font-size: 14px;
                color: $ypo-black-opac !important;
                font-weight: 600;
            }
        }

        .v-select__slot {
            .v-label {
                color: $ypo-black-opac !important;
            }
        }

        .vue-star-rating {
            margin-bottom: 10px;
            padding: 0;

            label {
                font-size: 20px;
                padding: 0;
                margin-right: 5px;
                color: rgba($ypo-blue, 0.5);
            }
        }

        .action-btns {
            margin-bottom: 20px;

            .v-btn {
                background: none;
                display: inline-flex;
                margin: 0 20px 0 0;

                &:hover:before {
                    background-color: inherit;
                }

                &:focus:before {
                    background: inherit;
                }

                .v-icon {
                    color: rgba($ypo-blue, 0.5);
                    font-size: 25px;

                    &:hover,
                    &.active {
                        color: $ypo-blue;
                    }
                }
            }
        }

        .file-upload {
            .upload {
                border: 1px dashed rgba(8, 48, 80, 0.4);
                padding: 20px;
                border-radius: 5px;
                margin-top: 15px;
                align-items: center;
                display: flex;

                .fa-image {
                    color: rgba($ypo-blue, 0.7);
                    font-size: 18px;
                    padding-right: 5px;
                }

                label {
                    color: rgba($ypo-cta, 0.9);
                    font-size: 14px;
                    padding-left: 5px;
                }
            }

            .tiles {
                margin-top: 15px;

                .v-image__image {
                    background-repeat: no-repeat;
                    height: 80px;
                    max-width: 80px;
                    border-radius: 5px;
                    border: 1px solid rgba(8, 48, 80, 0.4);
                }

                &__image {
                    position: relative;
                    display: inline-flex;

                    .v-btn {
                        position: absolute;
                        top: -5px;
                        margin: 8px;
                        padding: 0;
                        width: auto;
                        height: auto;
                        right: 10px;

                        .v-btn__content {
                            background-color: $ypo-cta;
                            color: $white;
                            height: 22px;
                            width: 22px;
                            position: absolute;
                            border: 2px $white solid;
                        }

                        .v-icon {
                            font-size: 12px;
                            font-weight: bold;
                            padding-top: 1px;
                        }
                    }
                }
            }

        }

        .error-color {
            font-size: 12px;
            margin-top: -10px;
            display: flex;
            margin-bottom: 20px;
        }

        .thank-you {
            padding: 100px 130px;
            font-family: Raleway, serif;
            font-weight: 500;
            text-align: center;
            display: none;

            strong {
                font-size: 28px;
                color: $ypo-blue;
            }

            p {
                margin-top: 10px;
            }
        }

        &__success {
            text-align: center;
            padding: 50px 50px;

            h1 {
                color: $ypo-blue;
                font-size: 24px;
                margin: 0px 0 5px 0;
                padding: 0;
                font-weight: 500;
            }
        }
    }
</style>
